import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GameStep, LoginSteps, ModalStep } from "../../types/config";
interface prop {
  gameSteps: GameStep;
  loginSteps: LoginSteps;
  token?: string;
  modalStep: ModalStep;
  is_game_active: boolean;
}
const initialState: prop = {
  gameSteps: GameStep.HOME,
  loginSteps: LoginSteps.PHONE,
  modalStep: ModalStep.DEFAULT,
  is_game_active: true,
};
export const configSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    setGameStep(state, action: PayloadAction<GameStep>) {
      state.gameSteps = action.payload;
    },
    setLoginStep(state, action: PayloadAction<LoginSteps>) {
      state.loginSteps = action.payload;
    },
    setModalStep(state, action: PayloadAction<ModalStep>) {
      state.modalStep = action.payload;
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setActiveGame(state, action: PayloadAction<boolean>) {
      state.is_game_active = action.payload;
    },
  },
});
export const configAction = configSlice.actions;
export default configSlice.reducer;
